<script>
    export let sections;
    export let currentSection;
</script>

<style>
    .scroll-indicator {
        position: fixed;
        top: 10px;
        left: 10px;
        background-color: rgba(255, 255, 255, 0.8);
        padding: 10px;
        border-radius: 5px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        z-index: 100;
        display: flex;
        flex-direction: column;
    }

    .dot {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: gray;
        margin: 5px 0;
    }

    .dot.active {
        background-color: black;
    }

    @media (min-width: 768px) {
        .scroll-indicator {
            display: none;
        }
    }
</style>

<div class="scroll-indicator">
    {#each sections as section, i}
        <div class="dot {currentSection === i ? 'active' : ''}"></div>

    {/each}
</div>
